import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';

export const getNewsCategoryUrl = (showGlobalNav: boolean, label: string) => {
	return `${GlobalRoutes.NewsHome}${
		showGlobalNav ? `?category=${label}` : `?global_nav=0&category=${label}`
	}`;
};
